document.addEventListener('click', async function (e) {
  var btn = e.target.closest && e.target.closest('[data-sticky-buy-now]');
  if (!btn || btn.disabled) return;
  e.preventDefault();

  var form = document.getElementById(btn.getAttribute('data-form-id'));
  if (!form) {
    console.warn('Sticky buy now: product form not found');
    return;
  }

  var label = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Please wait...';

  try {
    // form-associated fields (form="..." attribute wale) bhi isme aate hain
    var data = new FormData(form);
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    });

    if (!res.ok) {
      console.warn('Sticky buy now failed', res.status, await res.text());
      throw new Error('add failed');
    }

    window.location.href = '/checkout';
  } catch (err) {
    btn.disabled = false;
    btn.textContent = label;
  }
});